import React from 'react';
import { FloatingDropdown } from 'wix-ui-tpa/cssVars';
import { useTranslate } from '../../context/api-context/translations/use-translate';
import { useConfiguration } from '../../context/configuration-context/use-configuration';
import { useApi } from '../../context/api-context/use-api';
import { getIsMobile } from '../../../common/store/base-params/base-params-selectors';
import { SORTING_SELECTOR } from '../../../common/constants/data-hooks';
import { useCommentsSort } from './use-comments-sort';
import { classes, st } from './comments-sort.st.css';
export const CommentsSort = ({ className, selectedSort }) => {
    const { blackAndWhiteModals } = useConfiguration();
    const isMobile = useApi(getIsMobile);
    const t = useTranslate();
    const { sortOptions, onSortChange } = useCommentsSort();
    return (React.createElement(FloatingDropdown, { "data-hook": SORTING_SELECTOR, className: st(classes.root, { isMobile, blackAndWhite: !!blackAndWhiteModals }, className), label: isMobile ? '' : t('header.sort-by'), value: selectedSort, options: sortOptions, onChange: (option) => onSortChange?.(option.id) }));
};
//# sourceMappingURL=comments-sort.js.map